/**
 * breadcrumb-trail.js  v2 — server-rendered breadcrumbs are always authoritative.
 *
 * Liquid snippets (collection-breadcrumb.liquid, product-breadcrumb.liquid)
 * render the correct trail on every full page load. This script NEVER rewrites
 * the DOM on init — that caused stale sessionStorage to show wrong trails until
 * a hard refresh. It only:
 *   1. Syncs sessionStorage FROM the server-rendered nav (baseline for clicks)
 *   2. On data-crumb-trail clicks, stores the merged trail for the next page
 *      (the next page still renders from Liquid; storage is kept in sync only)
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'labsafe:crumbTrail';
  var GENERIC_HREFS = ['/', '/collections', '/collections/all'];

  function normalizePath(url) {
    if (!url) return '';
    var path = String(url).split('?')[0].split('#')[0];
    if (path.length > 1 && path.charAt(path.length - 1) === '/') {
      path = path.slice(0, -1);
    }
    return path;
  }

  function isGenericHref(url) {
    return GENERIC_HREFS.indexOf(normalizePath(url)) !== -1;
  }

  function readTrailFromRenderedNav(nav, hereUrl) {
    var trail = [];
    var anchors = nav.querySelectorAll('a[href]');
    for (var i = 0; i < anchors.length; i++) {
      var href = anchors[i].getAttribute('href');
      if (!href || isGenericHref(href)) continue;
      trail.push({ title: anchors[i].textContent.trim(), url: href });
    }
    var active = nav.querySelector('[aria-current="page"]');
    if (active) {
      trail.push({ title: active.textContent.trim(), url: hereUrl });
    }
    return trail;
  }

  function writeTrail(trail) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trail.slice(-8)));
    } catch (e) {
      /* sessionStorage unavailable */
    }
  }

  function mergeClickTrail(nav, destTrail, herePath) {
    if (!nav || !destTrail.length) return destTrail;

    var displayed = readTrailFromRenderedNav(nav, herePath);
    if (!displayed.length) return destTrail;

    var destLeaf = destTrail[destTrail.length - 1];
    var ancestorCount = destTrail.length - 1;

    if (ancestorCount === 0) {
      return displayed.slice(0, -1).concat([destLeaf]);
    }

    var prefixMatch = displayed.length >= ancestorCount;
    if (prefixMatch) {
      for (var i = 0; i < ancestorCount; i++) {
        if (normalizePath(displayed[i].url) !== normalizePath(destTrail[i].url)) {
          prefixMatch = false;
          break;
        }
      }
    }

    if (!prefixMatch) {
      return displayed.slice(0, -1).concat([destLeaf]);
    }

    return destTrail;
  }

  /** Always trust the server-rendered breadcrumb; sync storage to match. */
  function syncFromServer() {
    var nav = document.querySelector('nav[aria-label="Breadcrumb"]');
    if (!nav) return;
    writeTrail(readTrailFromRenderedNav(nav, window.location.pathname));
  }

  document.addEventListener(
    'click',
    function (evt) {
      var link = evt.target.closest('a[data-crumb-trail]');
      if (!link) return;

      var nav = document.querySelector('nav[aria-label="Breadcrumb"]');
      var raw = link.getAttribute('data-crumb-trail');
      if (!raw) return;

      try {
        var destTrail = JSON.parse(raw);
        if (!Array.isArray(destTrail) || !destTrail.length) return;
        destTrail = mergeClickTrail(nav, destTrail, window.location.pathname);
        writeTrail(destTrail);
      } catch (e) {
        /* malformed trail JSON */
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFromServer);
  } else {
    syncFromServer();
  }

  /* Back/forward cache: re-sync from the restored server HTML, never override. */
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) syncFromServer();
  });
})();
